import { render, staticRenderFns } from "./remitDefiniteForPayEdit.vue?vue&type=template&id=2375b997"
import script from "./remitDefiniteForPayEdit.vue?vue&type=script&lang=js"
export * from "./remitDefiniteForPayEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports